"use client";
import * as React from "react";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Phone } from "lucide-react";


export default function Contact() {
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");

  // Handle form submission
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // You can add Recaptcha logic here to secure this endpoint
    fetch("/api/submit", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        fullName,
        email,
        phone,
        message,
      }),
    });
    setFullName("");
    setEmail("");
    setPhone("");
    setMessage("");
    alert("Thanks! We'll reach out to you soon.");
  };

  return (
    <section id="contact" className="py-4 lg:py-14 px-5 md:px-8 lg:px-0 w-full">
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row gap-8 lg:gap-12">
        {/* Left Content Section */}
        <div className="order-last lg:order-first pt-8 w-full lg:w-1/2 flex flex-col">
          <span className="text-primary mb-2">Contact Bishop Mercier</span>
          <h2 className="text-3xl lg:text-4xl font-bold text-foreground mb-4">
            Reach Our Team
          </h2>
          <p className="text-neutral-500 dark:text-foreground/80 mb-8">
            Bishop Mercier is ready to discuss your residential, commercial, or
            industrial construction needs across the city.
          </p>

          {/* Contact Information List */}
          <ul className="space-y-6 pb-10 mb-12 border-b border-border">
            <li className="flex items-center gap-4">
              <div className="bg-card text-card-foreground p-4 border rounded-full">
                <Phone className="w-6 h-6 text-primary" />
              </div>
              <div className="translate-y-0.5 flex flex-col">
                <a
                  href="#"
                  className="text-neutral-500 dark:text-foreground/80 hover:underline"
                >
                  <span className="lg:text-[1.75rem] font-medium">
                    514-945-8852
                  </span>
                </a>
              </div>
            </li>
          </ul>

          {/* Our Services Section */}
          <div className="mb-8">
            <h3 className="text-[1.75rem] font-extrabold text-primary mb-4 tracking-wide">
              OUR SERVICES
            </h3>
            <ul className="list-disc ml-6 mt-4 space-y-2 text-foreground">
              <li>Experts in exterior building envelope restoration</li>
              <li>
                Exterior structural engineered inspections of buildings and
                facades
              </li>
              <li>Flat roofs, tar & gravel</li>
              <li>Membranes and waterproofing</li>
              <li>Masonry and brickwork</li>
              <li>Exterior masonry cleaning</li>
              <li>Slate and terra cotta work</li>
              <li>Cement and block work</li>
              <li>Foundation</li>
              <li>Sealants, coatings and caulking</li>
              <li>Masonry cleaning</li>
              <li>Stucco</li>
              <li>Metalwork and copperwork</li>
            </ul>
          </div>
        </div>

        {/* Right Form Section */}
        <div className="order-first lg:order-last w-full lg:w-1/2">
          <form
            onSubmit={handleSubmit}
            className="border bg-card p-6 lg:p-8 rounded-md shadow-sm"
          >
            <h3 className="text-2xl font-bold text-card-foreground mb-6">
              Get a Free Quote
            </h3>

            <div className="space-y-4">
              <div className="flex flex-col gap-2">
                <span
                  htmlFor="name"
                  className="text-sm font-medium text-card-foreground"
                >
                  Your Name
                </span>
                <input
                  type="text"
                  id="name"
                  name="name"
                  required
                  className="h-14 px-6 rounded-md bg-card border"
                  placeholder={"Enter your name"}
                  value={fullName}
                  onChange={(e) => setFullName(e.target.value)}
                />
              </div>

              <div className="flex flex-col gap-2">
                <span
                  htmlFor="email"
                  className="text-sm font-medium text-card-foreground"
                >
                  Your Email
                </span>
                <input
                  type="email"
                  id="email"
                  name="email"
                  required
                  className="h-14 px-6 rounded-md bg-card border"
                  placeholder={"Enter your email"}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>

              <div className="flex flex-col gap-2">
                <span
                  htmlFor="phone"
                  className="text-sm font-medium text-card-foreground"
                >
                  Your Phone
                </span>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  required
                  className="h-14 px-6 rounded-md bg-card border"
                  placeholder={"Enter your phone"}
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                />
              </div>

              <div className="flex flex-col gap-2">
                <span
                  htmlFor="message"
                  className="text-sm font-medium text-card-foreground"
                >
                  Tell us about your project
                </span>
                <textarea
                  id="message"
                  name="message"
                  required
                  className="min-h-[125px] p-6 rounded-md bg-card border"
                  placeholder={"Type your message"}
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                />
              </div>

              <Button className="w-fit flex justify-center items-center px-12 h-14 bg-primary text-primary-foreground rounded-md font-bold hover:bg-primary/90 transition-colors">
                <span className="lg:text-[1.15rem]">Send Inquiry</span>
              </Button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
}
